import { Box, CircularProgress, Typography } from '@mui/material';
import backgroundDragon from '../../assets/background_dragon.png';
import { useAuthStore } from '../../stores/authStore.js';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuthStore();

  if (isLoading || !isAuthenticated) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          gap: 2,
          backgroundImage: `url(${backgroundDragon})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'auto',
          backgroundPosition: 'center',
        }}
      >
        <CircularProgress />
        <Typography sx={{ mt: 2 }}>
          {isLoading ? 'Loading...' : 'Redirecting to login...'}
        </Typography>
      </Box>
    );
  }

  return children;
};

export default ProtectedRoute;
